import $ from 'jquery';

export const SUPPORTS_TOUCH_CLASS = 'touch touchevents';
export const NO_SUPPORT_TOUCH_CLASS = 'no-touch no-touchevents';

export default (options = {}) => {
  const { win = window, doc = document } = options;
  const $html = $(doc.documentElement);
  const supportsTouch = 'ontouchstart' in win || win.DocumentTouch && doc instanceof DocumentTouch;

  if (supportsTouch) {
    return $html.addClass(SUPPORTS_TOUCH_CLASS);
  }

  return $html.addClass(NO_SUPPORT_TOUCH_CLASS);
};



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/feature-detects/touch.js